// extracted by mini-css-extract-plugin
export var background = "_68-0";
export var container = "_68-1";
export var contentItem = "_68-7";
export var extendedWarranty = "_68-5";
export var link = "_68-d";
export var modal = "_68-b";
export var modalCloseButton = "_68-9";
export var modalContent = "_68-3";
export var modalContentMain = "_68-6";
export var modalImageLogo = "_68-8";
export var modalLogo = "_68-a";
export var modalSideImage = "_68-4";
export var preview = "_68-c";
export var redoModal = "_68-2";